import React from 'react';
import { LockIcon } from 'lucide-react';
interface LockChipProps {
  label: string;
}
export function LockChip({
  label
}: LockChipProps) {
  return <span className="inline-flex items-center gap-1.5 border border-locked/60 bg-locked/[0.07] px-2 py-1 font-sans text-[10px] font-semibold tracking-[0.14em] text-locked" data-id="element-161" data-mp="1cukrh57m1a33">
      <LockIcon aria-hidden="true" className="h-3 w-3" strokeWidth={1.75} data-id="element-162" data-mp="1ml5owpbjs8kf" />
      {label.toUpperCase()}
    </span>;
}